// extracted by mini-css-extract-plugin
module.exports = {"container":"segmentTab__container___2sHHT","is-active":"segmentTab__is-active___2owsh","is-disabled":"segmentTab__is-disabled___3GwcJ"};